var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmotionSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 47.9966C37.2522 47.9966 47.9966 37.2522 47.9966 23.9983C47.9966 10.7444 37.2522 0 23.9983 0C10.7444 0 0 10.7444 0 23.9983C0 37.2522 10.7444 47.9966 23.9983 47.9966Z",
    fill: "#D8D8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86107 15.9192C4.05532 14.149 4.70228 12.4547 5.5891 10.9023C6.48606 9.35334 7.65329 7.94794 9.01309 6.76551C10.3712 5.58139 11.9236 4.61855 13.5824 3.94456C15.2428 3.27902 17.0114 2.87531 18.7918 2.93443C17.2496 3.81618 15.7935 4.63206 14.4185 5.55098C13.0418 6.45977 11.7479 7.43949 10.5232 8.50199C9.29855 9.56618 8.14821 10.7131 7.057 11.9513C5.95565 13.1861 4.94552 14.5138 3.85938 15.9192H3.86107Z",
    fill: "#BCBBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9969 23.9997C47.9969 37.2531 37.2536 47.9997 23.9969 47.9997C16.7536 47.9997 10.2604 44.7902 5.8584 39.7142C10.0695 43.3815 15.5763 45.5977 21.5982 45.5977C34.8516 45.5977 45.5982 34.8544 45.5982 21.5977C45.5982 15.5926 43.3938 10.1027 39.7452 5.8916C44.8009 10.2902 47.9952 16.77 47.9952 23.998L47.9969 23.9997Z",
    fill: "#D8D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9969 23.9997C47.9969 37.2531 37.2536 47.9997 23.9969 47.9997C16.7536 47.9997 10.2604 44.7902 5.8584 39.7142C10.0695 43.3815 15.5763 45.5977 21.5982 45.5977C34.8516 45.5977 45.5982 34.8544 45.5982 21.5977C45.5982 15.5926 43.3938 10.1027 39.7452 5.8916C44.8009 10.2902 47.9952 16.77 47.9952 23.998L47.9969 23.9997Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0523 31.0405C33.6063 30.6452 34.3394 31.2212 34.0641 31.8445C32.603 35.1401 28.6469 37.5033 23.9965 37.5033C19.3462 37.5033 15.3918 35.1401 13.929 31.8445C13.6536 31.2212 14.3867 30.6452 14.9408 31.0405C17.1351 32.603 20.3783 33.5912 23.9948 33.5912C27.6114 33.5912 30.8563 32.603 33.0506 31.0405H33.0523Z",
    fill: "#6F79D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0504 22.7469C33.8258 22.7469 35.265 20.6543 35.265 18.0729C35.265 15.4915 33.8258 13.3989 32.0504 13.3989C30.2751 13.3989 28.8359 15.4915 28.8359 18.0729C28.8359 20.6543 30.2751 22.7469 32.0504 22.7469Z",
    fill: "#6F79D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.944 22.7469C17.7194 22.7469 19.1586 20.6543 19.1586 18.0729C19.1586 15.4915 17.7194 13.3989 15.944 13.3989C14.1687 13.3989 12.7295 15.4915 12.7295 18.0729C12.7295 20.6543 14.1687 22.7469 15.944 22.7469Z",
    fill: "#6F79D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionSmile);
export default __webpack_public_path__ + "static/media/emotion-smile.a7e50a57.svg";
export { ForwardRef as ReactComponent };